<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <template v-if="circle">
      <path
        d="M4.34,8,9,12.66H4.34v2H11l4.67,4.66.87-.79L5.21,7.2Zm12.33,4.67h1v2h-1Zm-1.67,0h1v2H15Zm.6-5.4a2.25,2.25,0,0,0,.66-1.59h-1A1.23,1.23,0,0,1,14,6.87h0v1a2.66,2.66,0,0,1,2.67,2.66V12h1V10.61A3.8,3.8,0,0,0,15.6,7.26Zm-3,2.53h1a1.32,1.32,0,0,1,1.33,1.29V12h1V10.93A2.26,2.26,0,0,0,13.66,8.8h-1A1.38,1.38,0,0,1,11.4,7.5a1.2,1.2,0,0,1,1.2-1.2h0v-1A2.25,2.25,0,0,0,10.39,7.5a2.28,2.28,0,0,0,2.27,2.29H12.6Zm1.66,4.8V12.66H12.41Z"
      />
      <path d="M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24ZM12,1.5A10.5,10.5,0,1,0,22.5,12,10.5,10.5,0,0,0,12,1.5Z" />
    </template>
    <path
      v-else
      d="M1.33,5.52,8.8,12.86H1.33V16H12l7.47,7.33,1.38-1.26L2.72,4.27Zm19.74,7.34h1.6V16h-1.6Zm-2.67,0H20V16H18.4Zm1-8.49a3.66,3.66,0,0,0,1.07-2.51h-1.6a1.93,1.93,0,0,1-1.95,1.89H16.8V5.31a4.28,4.28,0,0,1,4.27,4.26v2.24h1.6V9.61a5.89,5.89,0,0,0-3.31-5.24Zm-4.69,4h1.6a2.08,2.08,0,0,1,2.13,2v1.43H20V10.13a3.56,3.56,0,0,0-3.73-3.35h-1.6a2.17,2.17,0,0,1-2-2.09A1.92,1.92,0,0,1,14.59,2.8h.08V1.33A3.55,3.55,0,0,0,11,4.79,3.63,3.63,0,0,0,14.67,8.35Zm2.66,7.55v-3H14.24Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'NoSmokeIcon',
  props: {
    circle: { type: Boolean, default: false },
  },
}
</script>
